import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kit",
  "use": "icon-kit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-kit\"><path fill=\"#333333\" d=\"M35.84 457.728l288.768-303.104v154.624L128 507.904v2.048l195.584 199.68v154.624L35.84 560.128v-102.4z m663.552 253.952L894.976 512v-2.048L699.392 310.272v-153.6L988.16 460.8v106.496L699.392 869.376V711.68z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol